import { LanguageService } from './language.service';
//Angular
import { Http, Headers, URLSearchParams, RequestOptions } from "@angular/http";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { CacheService } from '../core/cache.service';
import { ApiService } from '../core/api.service';
import { ShoppingCartService } from '../inventory/shopping-cart.service';
import { Mappings } from '../../shared/mapping';
import { HttpParam } from "./../../models/core/http-param";
import { QuickRegister } from '../../models/cms/register';

@Injectable()
export class LoginService {
    constructor
        (
            public _api: ApiService,
            public _cache: CacheService,
            private mappings: Mappings,
            private cartService: ShoppingCartService,
            private langService: LanguageService
        ) { }

    sendLoginRequest(email: string, password: string) {
        let cartId = this.cartService.getCartId();

        let url = this.mappings.Web_Api_Post_Send_Login_Request

        let key = url; let x = 0;

        let params = {
            Email: email.toLowerCase(),
            Password: btoa(password),
            CartID: cartId
        }

        return this._api.post(url, params);
    }

    authentificateUser(email: string, firstName: string, lastName: string) {
        let cartId = this.cartService.getCartId();

        let url = this.mappings.Web_Api_Post_User_Authentification

        let lang = this.langService.getLongLang();
        let key = url;

        let params = {
            Email: email.toLowerCase(),
            Password: "",
            FirstName: firstName,
            LastName: lastName,
            CartID: cartId,
            Lang: lang
        }

        return this._api.post(url, params);
    }

    quickRegister(userInfo: QuickRegister) {
        let cartId = this.cartService.getCartId();

        let url = this.mappings.Web_Api_Post_User_Authentification

        let lang = this.langService.getLongLang();
        let key = url;

        let params = {
            Email: userInfo.EmailRegister != null ? userInfo.EmailRegister.toLowerCase() : '',
            Password: userInfo.Password,
            FirstName: '',
            LastName: '',
            CustomerGroup: userInfo.CustomerGroup,
            CartID: cartId,
            Lang: lang,
            CodiceFiscale: userInfo.CodiceFiscale,
            PartitaIva: userInfo.PartitaIva,
            Newsletter: userInfo.Newsletter
        }

        return this._api.post(url, params);
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/login.service.ts